
function P (props){
    return (
        <p>{props.t}</p>
    );
};

export default P;